import api from './api';
import { TarionUnit, TarionFilters, TarionListResponse } from '../types/tarion';

export const tarionService = {
  // Get all units for Tarion
  getAll: async (
    workspaceId: string,
    filters?: TarionFilters,
    page?: number,
    limit?: number,
    sortBy?: string,
    sortOrder?: 'asc' | 'desc'
  ): Promise<TarionListResponse> => {
    const params: any = {
      page: page || 1,
      limit: limit || 50,
      sortBy: sortBy || 'unitNo',
      sortOrder: sortOrder || 'asc',
      ...filters
    };

    const response = await api.get(`/workspaces/${workspaceId}/tarion/units`, { params });
    return response.data;
  },

  // Bulk update occupancy dates
  bulkUpdateOccupancyDates: async (
    workspaceId: string,
    unitIds: string[],
    occupancyDates: {
      tentative1Occupancy?: string | null;
      tentative2Occupancy?: string | null;
      finalOccupancy?: string | null;
      firmOccupancy?: string | null;
    }
  ): Promise<any> => {
    const response = await api.post(`/workspaces/${workspaceId}/tarion/bulk-update`, {
      unitIds,
      occupancyDates
    });
    return response.data;
  },

  // Export Tarion data
  exportData: async (workspaceId: string, filters?: TarionFilters): Promise<Blob> => {
    const params: any = { ...filters };
    const response = await api.get(`/workspaces/${workspaceId}/tarion/export`, {
      params,
      responseType: 'blob'
    });
    return response.data;
  }
};
